// NOTE: The `TRANSLATE_TO_*` member values below intentionally duplicate the
// string values of `SupportedTranslationLanguages` (in `./prompts/translate/types`).
// Under TypeScript's `--isolatedDeclarations`, enum member initializers cannot
// reference external symbols (TS9020), so we cannot write
// `TRANSLATE_TO_FRENCH = \`Translate to ${SupportedTranslationLanguages.French}\``.
// If you add or change a `SupportedTranslationLanguages` value, update the
// matching `TRANSLATE_TO_*` entry here as well. The runtime construction in
// `./prompts/translate/translate.tsx` (`\`Translate to ${language}\``) must
// produce the same strings as these enum values.

export enum CONFIG_ITEM_KEYS {
	ADD_STRUCTURE = 'Add structure',
	BRAINSTORM = 'Brainstorm',
	CHANGE_TONE_TO_CASUAL = 'Change tone to casual',
	CHANGE_TONE_TO_EDUCATIONAL = 'Change tone to educational',
	CHANGE_TONE_TO_EMPATHETIC = 'Change tone to empathetic',
	CHANGE_TONE_TO_NEUTRAL = 'Change tone to neutral',
	CHANGE_TONE_TO_PROFESSIONAL = 'Change tone to professional',
	CREATE_PULL_REQUEST_DESCRIPTION = 'Create pull request description',
	DESCRIBE_YOUR_PULL_REQUEST = 'Describe your pull request',
	FIND_ACTION_ITEMS = 'Find action items',
	FIX_SPELLING_AND_GRAMMAR = 'Fix spelling & grammar',
	FREE_GENERATE = 'AI (Atlassian Intelligence)',
	FREE_GENERATE_EDITOR_AGENT = 'AI (Atlassian Intelligence) Editor Agent',
	FREE_GENERATE_AIFC = 'AI (Atlassian Intelligence) AIFC',
	IMPROVE_WRITING = 'Improve writing',
	MAKE_SHORTER = 'Make shorter',
	ROVO_AGENT = 'Rovo agent',
	SHORTEN_UPDATE = 'Shorten update',
	SUGGEST_A_TITLE = 'Suggest a title',
	SUGGEST_RESPONSE = 'Draft a Reply',
	DRAFT_REPLY_PILL = 'Draft a Reply Pill',
	GENERATE_ESCALATION_NOTES = 'Generate escalation notes',
	INCIDENT_SMART_COMMENTS = 'Incident smart comments',
	SUGGEST_A_COMMENT = 'Suggest a comment',
	SUGGEST_A_REPLY = 'Suggest a reply',
	SUMMARISE_WRITING = 'Summarize writing',
	SUMMARIZE_SMART_LINK = 'Summarize smart link',
	MAKE_LONGER = 'Make longer',
	REPHRASE = 'Rephrase',
	ADD_INTRODUCTION = 'Add introduction',
	ADD_CONCLUSION = 'Add conclusion',
	CONVERT_TO_BULLETED_LIST = 'Convert to bulleted list',
	CONVERT_TO_TABLE = 'Convert to table',
	TRANSLATE_TO_CHINESE_SIMPLIFIED = 'Translate to chineseSimplified',
	TRANSLATE_TO_CHINESE_TRADITIONAL = 'Translate to chineseTraditional',
	TRANSLATE_TO_CZECH = 'Translate to czech',
	TRANSLATE_TO_DANISH = 'Translate to danish',
	TRANSLATE_TO_DUTCH = 'Translate to dutch',
	TRANSLATE_TO_ENGLISH = 'Translate to english',
	TRANSLATE_TO_FINNISH = 'Translate to finnish',
	TRANSLATE_TO_FRENCH = 'Translate to french',
	TRANSLATE_TO_GERMAN = 'Translate to german',
	TRANSLATE_TO_HUNGARIAN = 'Translate to hungarian',
	TRANSLATE_TO_ITALIAN = 'Translate to italian',
	TRANSLATE_TO_JAPANESE = 'Translate to japanese',
	TRANSLATE_TO_KOREAN = 'Translate to korean',
	TRANSLATE_TO_NORWEGIAN = 'Translate to norwegian',
	TRANSLATE_TO_POLISH = 'Translate to polish',
	TRANSLATE_TO_PORTUGUESE_BRAZILIAN = 'Translate to portugueseBrazilian',
	TRANSLATE_TO_RUSSIAN = 'Translate to russian',
	TRANSLATE_TO_SPANISH = 'Translate to spanish',
	TRANSLATE_TO_SWEDISH = 'Translate to swedish',
	TRANSLATE_TO_TURKISH = 'Translate to turkish',
	TRANSLATE_TO_THAI = 'Translate to thai',
	TRANSLATE_TO_UKRAINIAN = 'Translate to ukrainian',
	TRANSLATE_TO_VIETNAMESE = 'Translate to vietnamese',
	EXPERIMENTAL_PROMPT_PLACEHOLDER = 'Experimental prompt placeholder',
	ADD_POLISH = 'Add polish',
	SMARTLINK_EXTRACT_ACTIONS = 'Smartlink extract actions',
	SMARTLINK_EXTRACT_LIST = 'Smartlink extract list',
	SMARTLINK_DRAFT_CONTENT = 'Smartlink draft content',
}
